import React, { Component } from 'react'
import moment from 'moment'
import { FormattedRelativeTime } from 'react-intl'
import PropTypes from 'prop-types'

const MINUTE = 60
const HOUR = 60 * 60
const DAY = 60 * 60 * 24
const MONTH = 60 * 60 * 24 * 30
const YEAR = 60 * 60 * 24 * 365

function selectUnit(seconds) {
  const absValue = Math.abs(seconds)

  if (absValue < MINUTE) {
    return { unit: 'second', unitDuration: 1 }
  }

  if (absValue < HOUR) {
    return { unit: 'minute', unitDuration: MINUTE }
  }

  if (absValue < DAY) {
    return { unit: 'hour', unitDuration: HOUR }
  }

  if (absValue < MONTH) {
    return { unit: 'day', unitDuration: DAY }
  }

  if (absValue < YEAR) {
    return { unit: 'month', unitDuration: MONTH }
  }

  return { unit: 'year', unitDuration: YEAR }
}

export default class FormattedRelative extends Component {
  static propTypes = {
    value: PropTypes.any.isRequired,
    updateIntervalInSeconds: PropTypes.number,
  }

  render() {
    const value = Math.floor((moment(this.props.value) - moment()) / 1000)
    const { unit, unitDuration } = selectUnit(value)
    return (
      <FormattedRelativeTime
        numeric="auto"
        unit={unit}
        updateIntervalInSeconds={
          ['month', 'year', 'day'].includes(unit) ? undefined : this.props.updateIntervalInSeconds || 1
        }
        value={Math.round(value / unitDuration)}
      />
    )
  }
}
